import request from '../utils/requestApp.js'

// 公共的
// 公证类别
export function category() {
  return request({
    url: '/wechat/api/category',
    method: 'post',
  })
}

// 用途
export function purpose() {
  return request({
    url: '/wechat/api/purpose',
    method: 'post',
  })
}

// 使用地
export function place(data) {
  return request({
    url: '/wechat/api/place',
    method: 'post',
	data:data
  })
}

// 事项
export function matter(data) {
  return request({
    url: '/wechat/api/matter',
    method: 'post',
	data:data
  })
}

// 语种
export function language(data) {
  return request({
    url: '/wechat/api/language',
    method: 'post',
	data:data
  })
}


// 提交预约
export function setAppointment(data) {
  return request({
    url: '/wechat/api/setWebAppointment',
    method: 'post',
	data:data
  })
}

// 保存基本信息
export function setInfo(data) {
  return request({
    url: '/wechat/api/setWebInfo',
    method: 'post',
	data:data
  })
}

// 注册
export function webSiteRegister(data) {
  return request({
    url: '/wechat/api/webSiteRegister',
    method: 'post',
	data:data
  })
}
 
 // 验证码
 export function sendWebPhoneCode(data) {
   return request({
     url: '/wechat/api/sendWebPhoneCode',
     method: 'post',
 	data:data
   })
 }

// 验证手机是否注册
export function isWebSitePhoneRegister(data) {
  return request({
    url: '/wechat/api/isWebSitePhoneRegister',
    method: 'post',
	data:data
  })
}

// 登陆
export function webLogin(data) {
  return request({
    url: '/wechat/api/webLogin',
    method: 'post',
	data:data
  })
}

// 修改密码
export function webSiteForgetPassWord(data) {
  return request({
    url: '/wechat/api/webSiteForgetPassWord',
    method: 'post',
	data:data
  })
}

// 咨询
export function setWebConsulting(data) {
  return request({
    url: '/wechat/api/setWebConsulting',
    method: 'post',
	data:data
  })
}
// 首页列表
export function getHomeConsultingList(data) {
  return request({
    url: '/wechat/api/getHomeConsultingList',
    method: 'post',
	data:data
  })
}

// 新增人员
export function registerUser(data) {
  return request({
    url: '/wechat/api/registerUser',
    method: 'post',
	data:data
  })
}

// 人员列表
export function getUserList(data) {
  return request({
    url: '/wechat/api/getUserList',
    method: 'post',
	data:data
  })
}

// 事项保存
export function setMatter(data) {
  return request({
    url: '/wechat/api/setMatter',
    method: 'post',
	data:data
  })
}

// 获取需要上传的材料
export function material(data) {
  return request({
    url: '/wechat/api/material',
    method: 'post',
	data:data
  })
}

// 上传的材料
export function setWebMaterial(data) {
  return request({
    url: '/wechat/api/setWebMaterial',
    method: 'post',
	data:data
  })
}

// 申办提交
export function sbsubmit(data) {
  return request({
    url: '/wechat/api/submit',
    method: 'post',
	data:data
  })
}


// 咨询列表
export function getConsultingList() {
  return request({
    url: '/wechat/api/getConsultingList',
    method: 'post',
  })
}
// 预约列表
export function getAppointmentList() {
  return request({
    url: '/wechat/api/getAppointmentList',
    method: 'post',
  })
}
// 申办列表
export function order() {
  return request({
    url: '/wechat/api/order',
    method: 'post',
  })
}
// 修改密码
export function webChangePassWord(data) {
  return request({
    url: '/wechat/api/webChangePassWord',
    method: 'post',
	data:data
  })
}

// 最新咨询
export function getHomeSeeConsultingList() {
  return request({
    url: '/wechat/api/getHomeSeeConsultingList',
    method: 'post',
  })
}
